import { render } from "./FavoriteProperties.vue?vue&type=template&id=2e890dac"
import script from "./FavoriteProperties.vue?vue&type=script&lang=js"
export * from "./FavoriteProperties.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__